import { FunctionComponent } from "react";
import styles from "../stylesheets/components/breadcrumb.module.css";
import moduleBaseStyles from "../stylesheets/components/module-base.module.css";
import { AnchorAttrs, Language } from "../types/index.js";
import { getTranslations } from "../utils/utils.js";
import SmartLink from "./SmartLink.js";

interface Props {
  links: AnchorAttrs[];
  isPreview: boolean;
  languageId: Language;
}

const translations = {
  de: { location: "Sie sind hier:" },
  it: { location: "Voi siete qui:" },
  en: { location: "You are here:" },
  fr: { location: "Vous êtes ici:" },
};

const Breadcrumb: FunctionComponent<Props> = ({
  links,
  isPreview,
  languageId,
}) => {
  const i18n = getTranslations(languageId, translations);

  return (
    <nav aria-label="breadcrumb" className={styles.Breadcrumb}>
      <div className={moduleBaseStyles.Module__Wrapper}>
        {i18n.location}
        <ol className="Nav">
          {links.map((link, index) => {
            const isLast = index === links.length - 1;

            return isLast ? (
              <li aria-current="page" key={index}>
                {link.children}
              </li>
            ) : (
              <li key={index}>
                <SmartLink anchorAttrs={link} isPreview={isPreview} />
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumb;
